import { useEffect } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { ENDORSEMENTS_EXPERIMENT_KEY } from 'src/app/shared/components/endorsements';
import { useSessionStorageValue } from 'src/app/shared/hooks/storage';

export type UseDashboardEndorsements = ModelHookResult<{
	isEnabled: boolean;
}>;

export function useDashboardEndorsements(): UseDashboardEndorsements {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceDashboardEndorsementsExperiment: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	const isEnabled = variation === 'enabled';
	const [, setStoredValue] = useSessionStorageValue(ENDORSEMENTS_EXPERIMENT_KEY);

	// Store the experiment value in sessionStorage whenever it changes
	// This allows other pages (like petitionEditV2) to read the experiment value
	useEffect(() => {
		setStoredValue(variation);
	}, [variation, setStoredValue]);

	return {
		data: {
			isEnabled,
		},
	};
}
